import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import SignIn from "../views/auth/Signin.vue";
import UserHome from "../views/user/UserHome.vue";
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueRouter);
Vue.use(VueExcelXlsx);
const ifAuthenticated = (to, from, next) => {
  if (!store.getters.isLogin) {
    next("/");
  } else {
    next();
  }
};
const ifLogining = (to, from, next) => {
  if (!store.getters.isLogin) {
    next();
  } else {
    next("/panel");
  }
};
const ifConfig = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Configuracion" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifReport = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Reportes" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifStation = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Estacion" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifCompany = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Empresas" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifUser = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Usuarios" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifRol = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Roles" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifDevice = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Dispositivos" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const ifNetwork = (to, from, next) => {
  let rolStore = store.getters.getRol;
  let isRol = rolStore._modules
    .map((rol) => {
      if (rol.nameModule === "Redes" && rol.checkModule === true) {
        return rol;
      }
    })
    .filter((rol) => {
      return rol;
    });
  if (isRol.length == 1) {
    next();
  } else {
    next("/404");
  }
};
const routes = [
  {
    path: "/",
    name: "Signin",
    component: SignIn,
    beforeEnter: ifLogining
  },
  {
    path: "/404",
    name: "Route404",
    component: () => import("@/views/404.vue")
  },
  {
    path: "/panel",
    component: () => import("@/views/panel/Panel.vue"),
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "",
        name: "PanelHome",
        component: () => import("@/views/panel/PanelHome.vue")
      },
      {
        path: "/panel/user",
        name: "UserHome",
        component: UserHome,
        beforeEnter: ifUser
      },
      {
        path: "/panel/notify",
        name: "NotifyHome",
        component: () => import("@/views/notify/NotifyHome.vue"),
        beforeEnter: ifDevice
      },
      {
        path: "/panel/rol",
        name: "RolHome",
        component: () => import("@/views/rol/RolHome.vue"),
        beforeEnter: ifRol
      },
      {
        path: "/panel/station",
        name: "StationHome",
        component: () => import("@/views/station/StationHome.vue"),
        beforeEnter: ifStation
      },
      {
        path: "/panel/report",
        name: "ReportHome",
        component: () => import("@/views/report/ReportHome.vue"),
        beforeEnter: ifReport
      },
      {
        path: "/panel/company",
        name: "CompanyHome",
        component: () => import("@/views/company/CompanyHome.vue"),
        beforeEnter: ifCompany
      },
      {
        path: "/panel/configure",
        name: "ConfigHome",
        component: () => import("@/views/configure/ConfigHome.vue"),
        beforeEnter: ifConfig
      },
      {
        path: "/panel/devices",
        component: () => import("@/views/device/Devices.vue"),
        beforeEnter: ifDevice,
        children: [
          {
            path: "",
            name: "DeviceHome",
            component: () => import("@/views/device/DeviceHome.vue"),
            beforeEnter: ifDevice
          },
          {
            path: "/panel/devices_LoraWan/:id",
            name: "DeviceID_loRaWan",
            component: () => import("@/views/device/DeviceID_loRaWan.vue"),
            beforeEnter: ifDevice
          },
          {
            path: "/panel/devices_Lora/:id",
            name: "DeviceID_loRa",
            component: () => import("@/views/device/DeviceID_loRa.vue"),
            beforeEnter: ifDevice
          },
          {
            path: "/panel/devices/result",
            name: "DeviceTakeResult",
            component: () => import("@/views/device/DeviceTakeResult.vue"),
            beforeEnter: ifDevice
          }
        ]
      },
      {
        path: "/panel/network",
        component: () => import("@/views/network/Networks.vue"),
        beforeEnter: ifNetwork,
        children: [
          {
            path: "",
            name: "NetworkHome",
            component: () => import("@/views/network/NetworkHome.vue"),
            beforeEnter: ifNetwork
          },
          {
            path: "/panel/network/:id",
            name: "NetworkID",
            component: () => import("@/views/network/NetworkID.vue"),
            beforeEnter: ifNetwork
          }
        ]
      }
    ]
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
export default router;
